module.exports = __webpack_public_path__ + "media/images/about-page-09a6cf90.jpg";